
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1645 234","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"139.011","cy":"230.434","r":"85.941","fill":"#0b0c0f","transform":"translate(-72.098 -196.302) scale(1.35857)"}}),_c('circle',{attrs:{"cx":"139.011","cy":"230.434","r":"85.941","fill":"#0b0c0f","transform":"translate(210.133 -196.302) scale(1.35857)"}}),_c('circle',{attrs:{"cx":"139.011","cy":"230.434","r":"85.941","fill":"#0b0c0f","transform":"translate(492.364 -196.302) scale(1.35857)"}}),_c('circle',{attrs:{"cx":"139.011","cy":"230.434","r":"85.941","fill":"#0b0c0f","transform":"translate(774.595 -196.302) scale(1.35857)"}}),_c('circle',{attrs:{"cx":"139.011","cy":"230.434","r":"85.941","fill":"#0b0c0f","transform":"translate(1056.825 -196.302) scale(1.35857)"}}),_c('circle',{attrs:{"cx":"139.011","cy":"230.434","r":"85.941","fill":"#0b0c0f","transform":"translate(1339.055 -196.302) scale(1.35857)"}})])
          )
        }
      }
    